<template>
  <tbody class="thead">
    <tr>
      <template v-if="memberInfoColumnPosition === 0">
        <th v-if="tableShowMemberInfo">
          <ReportMemberFieldsColumnHeader type="info" />
        </th>
        <th v-if="tableShowMemberEmployment">
          <ReportMemberFieldsColumnHeader type="employment" />
        </th>
        <th v-if="walker.sub_show">
          {{ walker.sub_label }}
        </th>
        <th v-if="walker.third_show">
          {{ walker.third_label }}
        </th>
      </template>
      <template v-else-if="memberInfoColumnPosition === 1">
        <th v-if="walker.sub_show">
          {{ walker.sub_label }}
        </th>
        <th v-if="tableShowMemberInfo">
          <ReportMemberFieldsColumnHeader type="info" />
        </th>
        <th v-if="tableShowMemberEmployment">
          <ReportMemberFieldsColumnHeader type="employment" />
        </th>
        <th v-if="walker.third_show">
          {{ walker.third_label }}
        </th>
      </template>
      <template v-else>
        <th v-if="walker.sub_show">
          {{ walker.sub_label }}
        </th>
        <th v-if="walker.third_show">
          {{ walker.third_label }}
        </th>
        <th v-if="tableShowMemberInfo">
          <ReportMemberFieldsColumnHeader type="info" />
        </th>
        <th v-if="tableShowMemberEmployment">
          <ReportMemberFieldsColumnHeader type="employment" />
        </th>
      </template>
      <th>Timesheet status</th>
      <th>Time</th>
      <th v-if="tableShowActivity">Activity</th>
      <th v-if="tableShowApprovedOn">Approved on</th>
      <th v-if="tableShowApprovedBy">Approved by</th>
      <th v-if="previousReportQueryFilters.show_pay_rate">
        Pay rate
        <ReportTableTooltipIcon
          v-if="tableIsTeam"
          :message="ownershipSpentTooltip"
        />
      </th>
      <th v-if="tableShowSpent">
        {{ spentLabel }}
        <ReportTableTooltipIcon
          v-if="tableIsTeam"
          :message="ownershipSpentTooltip"
        />
        <ReportTableTooltipIcon
          :message="mismatchTooltip"
          placement="auto top"
          type="warning"
        />
      </th>
      <th v-if="previousReportQueryFilters.show_bill_rate">
        Bill rate
        <ReportTableTooltipIcon
          v-if="tableIsTeam"
          :message="ownershipBillableTooltip"
        />
      </th>
      <th v-if="previousReportQueryFilters.show_billed">
        Billed amount
        <ReportTableTooltipIcon :message="ownershipBillableTooltip" />
        <ReportTableTooltipIcon
          :message="mismatchTooltip"
          placement="auto top"
          type="warning"
        />
      </th>
      <th v-if="tableShowBillableTime">
        Billable time
        <ReportTableTooltipIcon :message="ownershipBillableTooltip" />
      </th>
      <th v-if="tableShowNonBillableTime">
        Non-billable time
        <ReportTableTooltipIcon :message="ownershipBillableTooltip" />
      </th>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapConstants } from '~/app_constants';

export default {
  name: 'TimesheetsReportTableHeader',
  computed: {
    spentLabel() {
      return this.tableIsTeam ? 'Spent' : 'Earned';
    },
    mismatchTooltip() {
      let text = '';

      if (this.tableSumDateRanges) {
        text = 'Amounts may not match payments due to rounding when date ranges are being summed';
      }

      return text;
    },
    ...mapGetters([
      'memberInfoColumnPosition',
      'previousReportQueryFilters',
      'tableIsTeam',
      'tableShowActivity',
      'tableShowApprovedBy',
      'tableShowApprovedOn',
      'tableShowBillableTime',
      'tableShowMemberEmployment',
      'tableShowMemberInfo',
      'tableShowNonBillableTime',
      'tableShowSpent',
      'tableSumDateRanges',
      'walker',
    ]),
    ...mapConstants(['ownershipSpentTooltip', 'ownershipBillableTooltip']),
  },
};
</script>
